module.exports = __webpack_public_path__ + "static/Comms-c1a42f4a2e8aeaa58e7336a08c1f64c8.svg";